import angular from 'angular';

import template from './tag.details.html';
import deleteConfirmModalTemplate from './_delete.attr.confirmation.modal.html';

class TagDetailsController {
  constructor(
    $scope,
    $filter,
    $state,
    $stateParams,
    $q,
    $uibModal,
    EquipmentService,
    TimezoneService,
    gettextCatalog,
    $ngRedux
  ) {
    'ngInject';

    this.$scope = $scope;
    this.$filter = $filter;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$q = $q;
    this.$uibModal = $uibModal;
    this.EquipmentService = EquipmentService;
    this.TimezoneService = TimezoneService;
    this.gettextCatalog = gettextCatalog;
    this.store = $ngRedux;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis)(this);

    this.EquipmentService.getTagById(this.$stateParams.id).then(
      response => {
        this.tag = response.data;
        this.filteredTagValues = angular.copy(this.tag.values);
        if (this.tag.dataType === 'Datetime') {
          if (this.tag.range.min) {
            this.tag.range.min = this.TimezoneService.tagToUserTimezone(this.tag.range.min);
          }
          if (this.tag.range.max) {
            this.tag.range.max = this.TimezoneService.tagToUserTimezone(this.tag.range.max);
          }
        }
        this.$scope.$emit('$viewContentLoaded'); //breadcrumb fix;
        this.loading = false;
      },
      error => {
        this.loading = false;
        let errorMsg = this.gettextCatalog.getString('An error occurred while retrieving attribute information');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = `${error.data.message} ${error.status.toString()} - ${error.statusText.toString()}`;
          } else {
            errorMsg += `: ${error.status.toString()} - ${error.statusText.toString()}`;
          }
        } else {
          errorMsg += this.gettextCatalog.getString('. Please try again later.');
        }
        this.onLoadErrorFlag = true;
        this.onLoadErrorText = errorMsg;
        return $q.reject();
      }
    );

    this.values = [];
    this.loading = true;
    this.tag = {
      key: '',
      properties: {
        constraints: {},
        values: []
      }
    };

    //Pagination
    this.currentPage = 1;
    this.currentPageExisting = 1;
    this.itemsPerPage = 25;
    this.maxSize = 1;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  mapStateToThis(state) {
    const {attributes} = state;

    let readonly = [];
    if (attributes != null && attributes.secured != null && attributes.secured.readonly) {
      readonly = readonly.concat(attributes.secured.readonly);
    }

    return {
      readonlyAttributes: readonly
    };
  }

  applyFilter() {
    this.filteredTagValues = this.$filter('filter')(this.tag.values, this.searchText);
  }

  editButtonClicked() {
    this.$state.go('admin.tag-edit', {
      id: this.$stateParams.id
    });
  }

  deleteButtonClicked() {
    const tag = this.tag;
    this.$uibModal.open({
      animation: true,
      template: deleteConfirmModalTemplate,
      controller: 'TagDeleteModalController',
      resolve: {
        tag: function() {
          return tag;
        }
      },
      size: 'md'
    });
  }

  isEditable() {
    const attributeKey = this.tag.key.toLowerCase();
    return this.readonlyAttributes.length === 0 || this.readonlyAttributes.indexOf(attributeKey) === -1;
  }
}

export const TagDetailsComponent = {
  template,
  controller: TagDetailsController,
  controllerAs: 'vm',
  bindings: {}
};
